module.exports = __webpack_public_path__ + "assets/81746d8d03e78a579e7f17fb4619699d.mp3";